import React from "react";
import { Card, Elevation, Tag, Button, H1, H3, NonIdealState, Spinner, Intent } from "@blueprintjs/core";
import { inject, observer } from "mobx-react";
import { apiCallPost, apiCallGet } from "../../../micro/fns/util";
import cogoToast from "cogo-toast";

class DischargeTemplates extends React.Component {
  state = {
    // Data
    templates: [],

    // Loading states
    isLoading: false,
    isSaving: false,

    // Form state
    newTemplate: {
      name: "",
      description: "",
      procedureType: "",
      templateContent: "",
      isActive: true,
    },
  };

  componentDidMount() {
    this.loadData();
  }

  loadData = async () => {
    try {
      this.setState({ isLoading: true });
      cogoToast.loading("Loading discharge templates...");

      const response = await apiCallPost(`/meta-sx/${this.props.authStore.prefix}/dischargeTemplates/getAll`, {});
      this.setState({ templates: response || [] });

      cogoToast.success("Discharge templates loaded successfully");
    } catch (err) {
      cogoToast.error("Failed to load discharge templates");
      console.error("Detailed error:", err);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  createTemplate = async () => {
    const { newTemplate } = this.state;

    // Validation
    if (!newTemplate.name || !newTemplate.description || !newTemplate.templateContent) {
      cogoToast.error("Please fill in all required fields");
      return;
    }

    try {
      cogoToast.loading("Creating discharge template...");
      this.setState({ isSaving: true });

      const templateData = {
        ...newTemplate,
        createdAt: new Date(),
        updatedAt: new Date(),
      };

      const res = await apiCallPost(`/meta-sx/${this.props.authStore.prefix}/dischargeTemplates/create`, templateData);

      // Add to local state
      this.setState((prevState) => ({
        templates: [...prevState.templates, res],
        newTemplate: {
          name: "",
          description: "",
          procedureType: "",
          templateContent: "",
          isActive: true,
        },
      }));

      cogoToast.success("Discharge template created successfully");
    } catch (err) {
      cogoToast.error("Failed to create discharge template");
      console.error("Detailed error:", err);
    } finally {
      this.setState({ isSaving: false });
    }
  };

  render() {
    const { isLoading } = this.state;

    if (isLoading) {
      return (
        <NonIdealState
          icon={<Spinner />}
          title="Loading Discharge Templates..."
          description="Please wait while we load the discharge template data"
        />
      );
    }

    return (
      <div
        style={{
          padding: "20px",
          backgroundColor: "var(--bg-primary)",
          color: "var(--text-primary)",
          minHeight: "100vh",
        }}
      >
        <div style={{ marginBottom: "20px" }}>
          <H1 style={{ color: "var(--text-primary)", margin: 0 }}>Discharge Templates</H1>
          <p style={{ color: "var(--text-secondary)", margin: "5px 0" }}>
            Create and manage discharge templates for different procedures and conditions
          </p>
        </div>

        <Card elevation={Elevation.TWO} style={{ padding: "20px" }}>
          <div style={{ textAlign: "center", padding: "40px" }}>
            <H3 style={{ color: "var(--text-primary)", marginBottom: "20px" }}>Discharge Templates</H3>
            <p style={{ color: "var(--text-secondary)", marginBottom: "30px" }}>
              This page will contain the Discharge Templates functionality.
              <br />
              Features will include:
            </p>
            <div
              style={{ display: "flex", flexWrap: "wrap", gap: "10px", justifyContent: "center", marginBottom: "30px" }}
            >
              <Tag large intent="primary">
                Template Editor
              </Tag>
              <Tag large intent="success">
                Procedure Mapping
              </Tag>
              <Tag large intent="warning">
                Condition Templates
              </Tag>
              <Tag large intent="danger">
                Document Management
              </Tag>
            </div>
            <Button large intent="primary" icon="add" onClick={this.createTemplate} loading={this.state.isSaving}>
              Create Template
            </Button>
          </div>
        </Card>
      </div>
    );
  }
}

export default inject("authStore")(observer(DischargeTemplates));
